export const NAME = 'name';
export const OWNER = 'ownerId';
export const GENERATE_NAME_AUTOMATICALLY = 'generateNameAutomatically';
export const IS_RE_ENGAGEMENT = 'isReEngagement';
export const MASTER_CAMPAIGN = 'masterCampaignId';
export const PLATFORMS = 'platforms';
export const BRIEF = 'briefId';
export const COUNTRY = 'countryCode';
export const CURRENCY = 'currencyCode';
export const SUB_TYPE = 'costModelSubTypeId';
export const REWARD_PACKAGE = 'rewardPackageId';
export const DYNAMIC_REWARD_PACKAGE = 'dynamicReward';

export const ADDITIONAL_REWARDS = 'additionalRewards';
export const DYNAMIC_ADDITIONAL_REWARDS = 'dynamicAdditionalRewards';
export const ADDITIONAL_REWARD_PACKAGE = 'packageId';
export const ADDITIONAL_REWARD_CONDITION = 'conditionId';
export const LANDING_PAGE = 'conversionPageId';
export const IOS_LANDING_PAGE = 'iOsConversionPageId';
export const ANDROID_LANDING_PAGE = 'androidConversionPageId';
export const PROMO_CODE = 'promoCodeId';
export const GG_LINKS = 'ggLinks';
export const COST_MODEL_END_DATE = 'costModelEndDate';
export const COST_MODEL_START_DATE = 'costModelStartDate';

export const TEMPLATE_ID = 'templateId';

export const AGENCY = 'agencyId';
export const INFLUENCER_CHANNEL = 'influencerChannelId';
export const COST_MODEL = 'costModel';
export const COST_MODEL_ID = 'costModelId';
export const PAYOUT = 'payout';

export const CREATIVE_URL = 'creativeUrl';

export const PROMO_LOCATION = 'promoLocationType';
export const PROMO_STARTING_POINT = 'promoStartingPoint';
export const PROMO_DURATION = 'promoDuration';

export const PORTAL = 1;
export const IOS = 2;
export const ANDROID = 3;
export const PLARIUM_PLAY = 5;

export const DEPENDENCIES = {
  [PLATFORMS]: [MASTER_CAMPAIGN],
  [BRIEF]: [MASTER_CAMPAIGN],
  [AGENCY]: [MASTER_CAMPAIGN],
  [INFLUENCER_CHANNEL]: [AGENCY],
  [LANDING_PAGE]: [MASTER_CAMPAIGN, `${GG_LINKS}.${PLATFORMS}`],
  [IOS_LANDING_PAGE]: [MASTER_CAMPAIGN],
  [ANDROID_LANDING_PAGE]: [MASTER_CAMPAIGN],
  [PROMO_CODE]: [MASTER_CAMPAIGN],
  [REWARD_PACKAGE]: [MASTER_CAMPAIGN],
  [DYNAMIC_REWARD_PACKAGE]: [MASTER_CAMPAIGN],
  [ADDITIONAL_REWARD_PACKAGE]: [MASTER_CAMPAIGN],
  [ADDITIONAL_REWARD_CONDITION]: [MASTER_CAMPAIGN],
  [COST_MODEL]: [MASTER_CAMPAIGN],
};
